// Importado antes de tudo em main.tsx: módulos ES avaliam importações antes do corpo do arquivo.
// Sem avaliação dinâmica de código (new Function): compatível com a CSP script-src 'self'.
import { z } from 'zod';

z.config({ jitless: true });
